WiseMetering.Views.NewScheduledReport = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',

    events: {
        'change #report-comparison-section': 'showFrequency',
        'change #report-details-section': 'showFrequency',
        'change #report-event-status-section': 'showFrequency',
        'change #report-file-section': 'showFrequency',
        'change #report-folder-section': 'showFrequency',
        'change #report-type': 'onTypeChange',
        'click #add-notification': 'onAddNotification',
        'click #remove-notification': 'onRemoveNotification'
    },

    form_prefix: 'report',

    frequencies: [
        { title: 'Daily', value: 'day' },
        { title: 'Weekly', value: 'week' },
        { title: 'Monthly', value: 'month' },
        { title: 'Quarterly', value: 'quarter' }
    ],

    input_readers: [
        { func: $element => $element.val() === '' ? null : $element.val(), type: 'hidden' },
        { func: $element => $element.val() === '' ? null : $element.val(), type: 'select' }
    ],

    template: 'templates/scheduled_reports/new',

    title: null,

    width: 500,

    eventStatuses: function() {
        return [
            {
                slug: 'all',
                name: i18next.t('common.all')
            },
            {
                slug: 'triggered',
                name: i18next.t('glossary.triggered')
            },
            {
                slug: 'not_triggered',
                name: i18next.t('glossary.not_triggered')
            }
        ];
    },

    eventsReportSettings: function(type) {
        const eventStatusElement = this.$('#report-event-status-section');

        if (['SiteEventsReport', 'OrganizationEventsReport'].includes(type)) {
            eventStatusElement.show();
        } else {
            eventStatusElement.hide();
        }
    },

    schemaReportSettings: function(type) {
        if (['SiteSchemaReport'].includes(type)) {
            this.showFrequency();
        }
    },

    zoneConsumptionSettings: function(type) {
        if (type === 'SiteConsumptionReport') {
            this.showFrequency();
            ['week', 'month', 'quarter'].forEach((item, i) => {
                $('#report-frequency option[value="' + item + '"]').attr('disabled', true);
            });
        }
    },

    folderReportSettings: function(type) {
        const folderElement = this.$('#report-folder-section');
        ['SiteFolderReport'].includes(type) ? folderElement.show() : folderElement.hide();
    },

    getFormData: function() {
        let data = this.formSerializer();
        if (data.folder_id) {
            // do nothing - folders don't need to send neither site_id or organization_id
        } else if (this.options.siteId) {
            delete data.folder_id;
            data.site_id = this.options.siteId;
        } else {
            delete data.folder_id;
            data.organization_id = WiseMetering.currentOrganization.id;
        }
        return data;
    },

    globalDetailedReportSettings: function(type) {
        if (type === 'OrganizationDetailedReport') {
            this.showFrequency();
        }
    },

    globalReports: function() {
        let reports = [], utilityKindReports = [], managementReports = [], otherReports = [], customReports = [];

        utilityKindReports.push({ title: 'All UtilityKinds', value: 'OrganizationUtilityReport', active: true });
        utilityKindReports.push({ title: 'UtilityKind', value: 'OrganizationUtilityReport', active: true });
        reports.push(['Utility', utilityKindReports]);

        managementReports.push({ title: 'Detailed', value: 'OrganizationDetailedReport', active: this.hasAccess('standardReports') });
        reports.push(['Management', managementReports]);

        otherReports.push({ title: 'Events', value: 'OrganizationEventsReport', active: true });
        reports.push(['Other', otherReports]);

        if (WiseMetering.currentOrganization.get('subdomain') === 'vodafoneiptv') {
            customReports.push({ title: 'Room Analysis', value: 'OrganizationVodafoneReport' });
            reports.push(['Custom', customReports]);
        }
        if (WiseMetering.currentOrganization.get('subdomain') === 'tp' && WiseMetering.currentUser.isSuperUser()) {
            customReports.push({ title: 'TagusPark Custom', value: 'OrganizationTagusParkReport' });
            reports.push(['Custom', customReports]);
        }

        return reports;
    },

    globalTagusPark: function(type) {
        if (type === 'OrganizationTagusParkReport') {
            this.showFrequency();
        }
    },

    globalVodafoneSettings: function(type) {
        const fileElement = this.$('#report-file-section');
        type === 'OrganizationVodafoneReport' ? fileElement.show() : fileElement.hide();
    },

    initializeForm: function() {
        this.$('#report-comparison').val('');
        this.$('#report-details').val('');
        this.$('#report-event-status').val('');
        this.$('#report-file').val('');
        this.$('#report-folder').val('');
        this.$('#report-frequency-section').hide();
        this.$('#report-frequency').val('');
        this.$('#report-frequency option').prop('disabled', false);
        this.$('#report-utility-kind').val('');
    },

    isCustomisedReport: function(type) {
        const customisations = ['OrganizationTagusParkReport', 'OrganizationVodafoneReport'];

        return customisations.includes(type);
    },

    onAddNotification: function() {
        this.$('#notification-list').append(JST['templates/reports/notification']({ userId: null }));
    },

    onRemoveNotification: function(event) {
        $(event.currentTarget).parent().remove();
    },

    onShow: function() {
        this.$('#report-description-section').hide();
        this.initializeForm();

        let language = WiseMetering.currentOrganization.get('language').toLowerCase();
        this.$('#report-language > option[value=\'' + language + '\']').prop('selected', true);
    },

    onTypeChange: function() {
        const type = this.$('#report-type').val();

        this.initializeForm();
        this.setReportDescription(type);
        this.utilityKindReportSettings(type);
        this.folderReportSettings(type);
        this.eventsReportSettings(type);
        this.schemaReportSettings(type);
        this.zoneConsumptionSettings(type);
        this.zoneDetailedReportSettings(type);
        this.globalDetailedReportSettings(type);

        // Custom Reports
        this.globalVodafoneSettings(type);
        this.globalTagusPark(type);
    },

    serializeData: function() {
        const now = moment();
        let folders = [];
        if (this.options.siteId) {
            folders = WiseMetering.folders.where({ site_id: this.options.siteId }).map(folder => {
                const id = folder.id;
                let depth = 0, name = folder.get('name'), parent = folder.parent();

                while (parent && parent.type() !== 'site') {
                    name = `${parent.get('name')} > ${name}`;
                    parent = parent.parent();
                    depth += 1;
                }
                return { depth, id, name };
            }).sort((a, b) => {
                // make the ones with depth 0 appear first
                if (a.depth === 0 || b.depth === 0) {
                    if (a.depth === b.depth) {
                        return a.name > b.name ? 1 : -1;
                    }
                    return a.depth > b.depth ? 1 : -1;
                } else {
                    return a.name > b.name ? 1 : -1;
                }
            });
        }

        let reports = this.options.siteId ? this.zoneReports() : this.globalReports();

        return Object.assign({}, this.model.toJSON(), {
            eventStatuses: this.eventStatuses(),
            folders,
            frequencies: this.frequencies,
            month: now.month() + 1,
            quarter: now.quarter(),
            reports,
            site_id: this.options.siteId,
            utility_kinds: WiseMetering.utilityKinds.map(x => ({ slug: x.get('slug'), name: x.get('name') })),
            year: now.year(),
            years: [now.year(), now.year() - 1, now.year() - 2]
        });
    },

    showFrequency: function() {
        this.$('#report-frequency-section').show();
    },

    utilityKindReportSettings: function(type) {
        const
            option = this.$('#report-type option:selected').text(),
            comparisonElement = this.$('#report-comparison-section'),
            utilityKindElement = this.$('#report-utility-kind-section'),
            isSingleUtilityKind = option === 'UtilityKind';

        ['SiteUtilityReport', 'OrganizationUtilityReport'].includes(type) ? comparisonElement.show() : comparisonElement.hide();
        isSingleUtilityKind ? utilityKindElement.show() : utilityKindElement.hide();
    },

    zoneDetailedReportSettings: function(type) {
        const detailsElement = this.$('#report-details-section');
        type === 'SiteDetailedReport' ? detailsElement.show() : detailsElement.hide();
    },

    zoneReports: function() {
        return [
            { title: i18next.t('reports.all_utility_kinds'), value: 'SiteUtilityReport', active: this.hasAccess('freeReports') },
            { title: i18next.t('reports.consumption_analysis'), value: 'SiteConsumptionReport', active: this.hasAccess('standardReports') },
            { title: i18next.t('reports.detailed'), value: 'SiteDetailedReport', active: this.hasAccess('standardReports') },
            { title: i18next.t('glossary.events'), value: 'SiteEventsReport', active: this.hasAccess('freeReports') },
            { title: i18next.t('glossary.folder'), value: 'SiteFolderReport', active: this.hasAccess('standardReports') },
            { title: i18next.t('reports.schema'), value: 'SiteSchemaReport', active: this.hasAccess('standardReports') }
        ];
    },

    setReportDescription: function(type) {
        let reportDescription = i18next.t('reports.common_report');
        const defaultDescription = i18next.t('reports.default_description');

        if (type === 'SiteUtilityReport' || type === 'SiteConsumptionReport' || type === 'OrganizationUtilityReport') {
            reportDescription = defaultDescription;
        } else if (type === 'SiteEventsReport' || type === 'OrganizationEventsReport') {
            reportDescription = i18next.t('reports.events_report');
        } else if (type === 'SiteFolderReport') {
            reportDescription = i18next.t('reports.folder_report');
        } else if (type === 'SiteSchemaReport') {
            reportDescription = i18next.t('reports.schema_report');
        } else if (type === 'OrganizationDetailedReport') {
            reportDescription = i18next.t('reports.global_detailed_report');
        } else if (type === 'SiteDetailedReport') {
            reportDescription = i18next.t('reports.zone_detailed_report');
        } else if (this.isCustomisedReport(type)) {
            reportDescription = i18next.t('reports.customized_report');
        }

        this.$('#report-description-section').show();
        this.$('#report-description-section').html(reportDescription);
    },

    hasAccess: function(type) {
        return WiseMetering.Permissions.hasPlanPermissions(type);
    }
});
